export const colorNeutral = '#ffffff';
export const colorNeutral400 = '#757373';
export const colorNeutral700 = '#3a3838';
export const colorGreyBackground = '#f4f4f4';
export const colorPrimary100 = '#fbe6e5';
export const colorPrimary500 = '#e03127';
export const colorPrimary600 = '#c32b22';
export const colorCommon80 = '#ca3629';
export const colorSecondary050 = '#faf9f9';
export const colorSecondary100 = '#f2f1f1';
export const colorSecondary200 = '#d9d6d7';
export const colorSecondary300 = '#bdb9ba';
export const colorSecondary400 = '#c3c2c2';
export const colorSecondary800 = '#3e3435';
export const colorSecondary900 = '#302322';
export const colorGuidance400 = '#67b2c7';
export const colorGuidance500 = '#017ea1';
export const colorGuidance700 = '#015871';
export const colorGuidance800 = '#003f50';
export const colorCommonBlue80 = '#eaf4ff';
export const colorBlue80 = '#2572cc';
export const colorBorder = '#f4f4f4';
export const colorPlaceholder = '#eff1f2';
export const colorSpinner = '#f3f3f3';
